/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../../magnolia/lib/MagnoliaPropertyHelper';

export interface switchableStruct {
  field: string;
  page: any;
  intLinkParam ? : string;
  external: string;
  download: Asset;
}
export interface mobileAspectRatioStruct {
  aspectRatio ? : string;
}
export default interface BrandImage {
  switchable ? : switchableStruct;
  linkTargetMode ? : string;
  title ? : string;
  image: Asset;
  aspectRatio ? : string;
  mobileAspectRatio ? : Array < mobileAspectRatioStruct > ;
  alt ? : string;
  showImageKiosk ? : boolean;
  showImageCatalog ? : boolean;
  metadata ? : any;
}

export const Props = {
  switchable: Object as() => switchableStruct,
  linkTargetMode: String,
  title: String,
  image: Object as() => Asset,
  aspectRatio: String,
  mobileAspectRatio: Array as() => Array < mobileAspectRatioStruct > ,
  alt: String,
  showImageKiosk: Boolean,
  showImageCatalog: Boolean,
  metadata: Object,
}

export const WrapperProps = {
  switchable: Object as() => switchableStruct,
  linkTargetMode: String,
  title: String,
  image: Object as() => Asset,
  aspectRatio: String,
  mobileAspectRatio: Object,
  alt: String,
  showImageKiosk: Boolean,
  showImageCatalog: Boolean,
  metadata: Object,
}

export class BrandImageBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class BrandImageInstance implements BrandImage {
      switchable ? : switchableStruct;
      linkTargetMode ? : string;
      title ? : string;
      image: Asset;
      aspectRatio ? : string;
      mobileAspectRatio ? : Array < mobileAspectRatioStruct > ;
      alt ? : string;
      showImageKiosk ? : boolean;
      showImageCatalog ? : boolean;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (this.switchable) {
          if (typeof this.switchable.download === 'object') {
            this.switchable.download = {
              ...this.switchable.download,
              link: this.switchable.download['@link'],
              name: this.switchable.download['@name'],
              path: this.switchable.download['@path'],
            };
          } else {
            this.switchable.download = null as any;
          }
        }
        if (typeof this.image === 'object') {
          this.image = {
            ...this.image,
            link: this.image['@link'],
            name: this.image['@name'],
            path: this.image['@path'],
          };
        } else {
          this.image = null as any;
        }
        if (this.mobileAspectRatio) {
          this.mobileAspectRatio = Object.entries(this.mobileAspectRatio)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'mobileAspectRatio' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
        } else {
          this.mobileAspectRatio = null as any;
        }
      }
    }
    return new BrandImageInstance(props);
  }
}
